exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wfh-btn-link[data-v-592bfb00]{color:#303030;font-family:Open Sans,sans-serif;font-size:16px;font-weight:600;letter-spacing:0;line-height:22px}.wfh-btn-link i[data-v-592bfb00]{margin:0 4px;color:#0db4e6}", ""]);

// exports
